/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import FinancialsManagedExternally from './FinancialsManagedExternally/index'
import No from './No/index'
import Normal from './Normal/index'
import React from 'react'
import Selection from './Selection/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/TreatmentPlans/Content/AcceptTreatmentAction/Content"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let treatmentPlansValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plans',
})
let treatmentShowFinancialsManagedExternallyValueData = fromData.useDataValue({ viewPath,
context: 'treatment',
path: 'show_financials_managed_externally',
})
let aggregateData = fromHelpers.getView(treatmentPlansValueData, treatmentShowFinancialsManagedExternallyValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: aggregateData,
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'FinancialsManagedExternally'}>
<FinancialsManagedExternally
  viewPath={`${viewPath}/FinancialsManagedExternally`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Normal'}>
<Normal
  viewPath={`${viewPath}/Normal`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Selection'}>
<Selection
  viewPath={`${viewPath}/Selection`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}